export type AdobeTargetBasketData = {
  origin?: string;
  hasPreSoldenProduct: boolean;
  isPreSoldenFulfilled: boolean;
  hasMultipleProducts: boolean;
};
